import { useEffect, useMemo, useState } from "react";
import { geoConicConformal, geoPath } from "d3-geo";

let geoCache = null;
const loadGeo = () => (geoCache ||= fetch("/geo/departements.geojson").then((r) => r.json()));

const W = 600, H = 580;

export const DepartmentMap = ({ departments = [], showAgents = false, editMode = false, onToggle, selected, onSelect, compact = false }) => {
  const [geo, setGeo] = useState(null);
  const [hover, setHover] = useState(null);
  useEffect(() => { loadGeo().then(setGeo); }, []);
  const byCode = useMemo(() => Object.fromEntries(departments.map((d) => [d.code, d])), [departments]);
  const path = useMemo(() => geo && geoPath(geoConicConformal().fitSize([W, H], geo)), [geo]);

  if (!geo) return <div className="h-64 grid place-items-center text-sm text-slate-400" data-testid="map-loading">Chargement de la carte…</div>;
  const info = hover && (byCode[hover.code] || { code: hover.code, name: hover.nom, sites: 0, off: true });

  return (
    <div className="relative" data-testid="department-map" onMouseLeave={() => setHover(null)}>
      <svg viewBox={`0 0 ${W} ${H}`} className={`w-full h-auto ${compact ? "max-h-[320px]" : "max-h-[640px]"}`}>
        {geo.features.map((f) => {
          const c = f.properties.code, on = !!byCode[c], sel = selected === c;
          return (
            <path
              key={c} d={path(f)} data-testid={`dept-${c}`} data-covered={on ? "1" : "0"}
              onMouseEnter={(e) => setHover({ ...f.properties, x: e.nativeEvent.offsetX, y: e.nativeEvent.offsetY })}
              onMouseMove={(e) => setHover({ ...f.properties, x: e.nativeEvent.offsetX, y: e.nativeEvent.offsetY })}
              onClick={() => (editMode ? onToggle?.(c) : onSelect?.(on ? c : null))}
              className="cursor-pointer transition-[fill,opacity] duration-200"
              style={{ fill: on ? "var(--brand-primary)" : "#e2e8f0", opacity: on ? (byCode[c].manual ? 0.65 : 1) : 1,
                       stroke: sel ? "#0f172a" : "#fff", strokeWidth: sel ? 2 : 0.7 }}
            />
          );
        })}
      </svg>
      {info && (
        <div data-testid="map-tooltip" className="pointer-events-none absolute z-10 bg-slate-900 text-white text-xs rounded-md px-3 py-2 shadow-lg"
             style={{ left: Math.min(hover.x + 14, 9999), top: hover.y + 14 }}>
          <div className="font-bold">{info.name} ({info.code})</div>
          {info.off ? <div className="text-slate-300">{editMode ? "Cliquer pour ajouter" : "Hors zone d'intervention"}</div> : (
            <>
              <div>{info.sites} site{info.sites > 1 ? "s" : ""}{info.manual ? " · ajouté manuellement" : ""}</div>
              {showAgents && info.agents != null && <div>{info.agents} agent{info.agents > 1 ? "s" : ""} affecté{info.agents > 1 ? "s" : ""}</div>}
            </>
          )}
        </div>
      )}
    </div>
  );
};
